import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, FormGroup, Input, Modal, ModalHeader, ModalBody, ModalFooter, Label, Table } from 'reactstrap';

import { API_BASE_URL } from "../config/api";

const API_BASE = API_BASE_URL;

function IconsSocialMedia() {
  const [socialMedias, setSocialMedias] = useState([]);
  const [newIcon, setNewIcon] = useState({ name: '', link: '' });
  const [newIconFile, setNewIconFile] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedIconId, setSelectedIconId] = useState(null);
  const [updateIcon, setUpdateIcon] = useState({ name: '', link: '', icon: '' });
  const [updateIconFile, setUpdateIconFile] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteIconId, setDeleteIconId] = useState(null);

  const fetchSocialMediaIcons = async () => {
    try {
      const response = await axios.get(`${API_BASE}/qr/socialMedia/list`);
      const data = response?.data;
      const list = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

      if (list.length === 0 && !(Array.isArray(data) || Array.isArray(data?.data))) {
        console.error('Invalid data format received:', data);
      }

      setSocialMedias(list);
    } catch (error) {
      console.error('Error fetching social media icons:', error);
    }
  };

  useEffect(() => {
    fetchSocialMediaIcons();
  }, []);

  const resolveIconUrl = (iconValue) => {
    if (!iconValue) return '';
    if (iconValue.startsWith('http://') || iconValue.startsWith('https://') || iconValue.startsWith('data:')) {
      return iconValue;
    }
    if (iconValue.startsWith('/')) return `${API_BASE}${iconValue}`;
    if (iconValue.startsWith('uploads/')) return `${API_BASE}/${iconValue}`;
    return `${API_BASE}/uploads/${iconValue}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewIcon({ ...newIcon, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('name', newIcon.name);
      formData.append('link', newIcon.link);
      if (newIconFile) formData.append('icon', newIconFile);

      await axios.post(`${API_BASE}/qr/socialMedia/add`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setNewIcon({ name: '', link: '' });
      setNewIconFile(null);
      fetchSocialMediaIcons();
    } catch (error) {
      console.error('Error adding social media icon:', error);
    }
  };

  const handleDeleteClick = (iconId) => {
    setDeleteIconId(iconId);
    setShowDeletePopup(true);
  };

  const performDelete = async () => {
    try {
      await axios.delete(`${API_BASE}/qr/socialMedia/delete/${deleteIconId}`);
      fetchSocialMediaIcons();
      setShowDeletePopup(false);
    } catch (error) {
      console.error('Error deleting social media icon:', error);
    }
  };

  const handleUpdate = (icon) => {
    setUpdateIcon({ ...icon });
    setUpdateIconFile(null);
    setSelectedIconId(icon.id);
    setShowUpdateForm(true);
  };

  const handleIconUpdate = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();
      formData.append('name', updateIcon.name || '');
      formData.append('link', updateIcon.link || '');
      if (updateIconFile) formData.append('icon', updateIconFile);

      await axios.put(`${API_BASE}/qr/socialMedia/update/${selectedIconId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      fetchSocialMediaIcons();
      setSelectedIconId(null);
      setShowUpdateForm(false);
      setUpdateIcon({ name: '', link: '', icon: '' });
      setUpdateIconFile(null);
    } catch (error) {
      console.error('Error updating social media icon:', error);
    }
  };

  return (
    <div className="content">
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="iconName">Name</Label>
          <Input
            type="text"
            name="name"
            id="iconName"
            placeholder="Social Media Name"
            value={newIcon.name}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label for="iconLink">Link</Label>
          <Input
            type="text"
            name="link"
            id="iconLink"
            placeholder="Social Media Link"
            value={newIcon.link}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label for="iconFile">Icon Image</Label>
          <Input
            type="file"
            id="iconFile"
            accept="image/*"
            onChange={(e) => setNewIconFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
          />
        </FormGroup>
        <Button type="submit">Add Icon</Button>
      </Form>

      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Link</th>
            <th>Icon</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {socialMedias.map((icon, index) => (
            <tr key={index}>
              <td>{icon.name}</td>
              <td><a href={icon.link} target="_blank" rel="noopener noreferrer">{icon.link}</a></td>
              <td>
                {icon.icon ? (
                  <img src={resolveIconUrl(icon.icon)} alt={icon.name} style={{ width: '30px', height: '30px' }} />
                ) : null}
              </td>
              <td>
                <Button color="success" onClick={() => handleUpdate(icon)}>Update</Button>
                {" "}
                <Button color="danger" onClick={() => handleDeleteClick(icon.id)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {showUpdateForm && (
        <div>
          <h4>Update Icon</h4>
          <Form onSubmit={handleIconUpdate}>
            <FormGroup>
              <Label for="updateIconName">Name</Label>
              <Input
                type="text"
                name="name"
                id="updateIconName"
                placeholder="Social Media Name"
                value={updateIcon.name}
                onChange={(e) => setUpdateIcon({ ...updateIcon, name: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label for="updateIconLink">Link</Label>
              <Input
                type="text"
                name="link"
                id="updateIconLink"
                placeholder="Social Media Link"
                value={updateIcon.link}
                onChange={(e) => setUpdateIcon({ ...updateIcon, link: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label for="updateIconFile">Icon Image</Label>
              <Input
                type="file"
                id="updateIconFile"
                accept="image/*"
                onChange={(e) => setUpdateIconFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              />
            </FormGroup>
            <Button color="primary" type="submit">Update</Button>
            <Button color="secondary" onClick={() => setShowUpdateForm(false)}>Cancel</Button>
          </Form>
        </div>
      )}

      <Modal isOpen={showDeletePopup} toggle={() => setShowDeletePopup(false)}>
        <ModalHeader toggle={() => setShowDeletePopup(false)}>Confirm Delete</ModalHeader>
        <ModalBody>Are you sure you want to delete this icon?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={performDelete}>Delete</Button>
          <Button color="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default IconsSocialMedia;
